<template>
  <v-container>
    <v-subheader>Upload</v-subheader>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <vue-csv-import
          :key="componentKey"
          ref="input-csv"
          v-model="obj.csv"
          :map-fields="obj.fields"
          tableClass="tableClass"
          :canIgnore="true"
          :headers="true"
        >
          <template slot="error">File type is invalid</template>

          <template slot="next" slot-scope="{ load }">
            <v-btn @click.prevent="load" color="primary" class="my-3">Load</v-btn>
          </template>

          <template slot="submit" slot-scope="{ submit }">
            <v-btn @click.prevent="submit" color="primary" class="my-3">Submit</v-btn>
          </template>
        </vue-csv-import>
        <v-btn @click="upload" color="primary" class="my-3" :disabled="!canUpload">Upload</v-btn>
      </v-col>
      <v-col v-if="obj.csv" cols="12" sm="6" md="8">
        <v-data-table :headers="headers" :items="obj.csv" :items-per-page="10"></v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VueCsvImport } from "vue-csv-import";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    VueCsvImport
  },
  props: {
    obj: Object
  },
  data() {
    return {
      componentKey: 0
    };
  },

  computed: {
    headers() {
      var dictionary = this.obj.fields;
      var arr = [];
      Object.keys(dictionary).forEach(function(key) {
        arr.push({
          text: dictionary[key],
          align: "left",
          sortable: false,
          value: key
        });
      });
      return arr;
    },
    canUpload() {
      return this.obj.data && this.obj.data.length > 0;
    }
  },
  methods: {
    ...mapActions({
      createBulkCandidates: "candidates/createBulk",
      createBulkClients: "clients/createBulk",
      createBulkInvoices: "invoices/createBulk",
      createBulkTimesheets: "timesheets/createBulk"
    }),
    async upload() {
      console.log(this.obj.data);
      if (this.obj.title == "Candidates") {
        await this.createBulkCandidates(this.obj.data);
      } else if (this.obj.title == "Clients") {
        await this.createBulkClients(this.obj.data);
      } else if (this.obj.title == "Invoices") {
        await this.createBulkInvoices(this.obj.data);
      } else if (this.obj.title == "Timesheets") {
        await this.createBulkTimesheets(this.obj.data);
      }
    }
  }
};
</script>

<style>
.tableClass td,
th {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
</style>
